import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/matchdayCard.css';
import overlayStyle from '../../../css/overlay.css';
// constants
import {ALL_MATCHDAY_MARKETS, BOTH_TEAMS_SCORE, UNDER_OVER_25, WIN_DRAW_WIN, UNDER_OVER_35} from '../constants/marketTypes';
// helpers
import {getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// containers
import MultiTab from '../containers/multitab';
// components
import WinDrawWin from '../components/winDrawWin';
import UnderOver from '../components/underOver';
import UnderOverThreeFive from '../components/underOverThreeFive';
import BothTeamsScore from '../components/bothTeamsScore';
import {
    HARD_SUSPENDED,
    NMB,
    PRE,
    RES,
    SOFT_SUSPENDED,
    VID,
    VPP_MATCHDAY_GREEK_CHANNEL
} from '../../../../../constants/identifiers';
import {getAllWrappedMatchdayBets} from '../../../helpers/betHelpers';
import MatchdayActiveBetsSummary from '../../../components/matchdayActiveBetsSummary';
import {OPERATOR} from "../../../../../constants/operator";
import {collapseAllMarkets, expandAllMarkets, expandCollapseMarket} from "../../matchday/actions/marketsActions";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        footballMarketsExpanded: state.vpp.footballMarketsExpanded,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets,
        matchdayUpdated: state.vpp.matchdayUpdated,
        systemLanguage: state.vpp.systemLanguage
    };
};

let availableTabs = [];

class MatchdayTextCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.allMarketRef = React.createRef();
        this.bttsRef = React.createRef();
        this.underOverThreeFiveRef = React.createRef();
        this.underOverRef = React.createRef();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            footballMarketsExpanded: storeData.vpp.footballMarketsExpanded,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets,
            matchdayUpdated: storeData.vpp.matchdayUpdated,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                footballMarketsExpanded: storeData.vpp.footballMarketsExpanded,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                channelEventBets: storeData.vpp.channelEventBets,
                matchdayUpdated: storeData.vpp.matchdayUpdated
            });
        }
    }

    _toggleMarkets(){
        if (!OPERATOR.expandAllMarkets && window.innerWidth < 950) {
            this.props.store.dispatch(collapseAllMarkets());
            this.props.store.dispatch(expandCollapseMarket(0))
        }
        else{
            this.props.store.dispatch(expandAllMarkets());
        }
    }
    componentDidMount() {
        this._toggleMarkets();
    }

    _generateMarketUI(marketCode, selectedMatchday, key) {
        let store = this.props.store;

        let matchdayMarkets = selectedMatchday.map((event) => {
            return {market: getMarketsByCode(marketCode, event.markets), event: event};
        });
        let content;
        let isGreekMatchday = selectedMatchday.channel === VPP_MATCHDAY_GREEK_CHANNEL ? true : false;
        if (matchdayMarkets.length > 0) {
            switch (marketCode) {
                case WIN_DRAW_WIN:
                    content = (<WinDrawWin callbacks={() => undefined} matchdayMarkets={matchdayMarkets} store={store}
                                           key={key} scrollRef={this.allMarketRef} standardView={false}
                                           isGreekMatchday={isGreekMatchday}/>);
                    break;
                case UNDER_OVER_25:
                    content = (
                        <UnderOver callbacks={() => undefined} matchdayMarkets={matchdayMarkets} store={store} key={key}
                                   scrollRef={this.underOverRef} standardView={false}
                                   isGreekMatchday={isGreekMatchday}/>);
                    break;
                case BOTH_TEAMS_SCORE:
                    content = (
                        <BothTeamsScore callbacks={() => undefined} matchdayMarkets={matchdayMarkets} store={store}
                                        key={key} scrollRef={this.bttsRef} standardView={false}
                                        isGreekMatchday={isGreekMatchday}/>);
                    break;
                default:
                    break;
            }
        }
        return content;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedMatchday = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let marketsOrderConfig = OPERATOR.matchdayMarketsOrder ? JSON.parse(OPERATOR.matchdayMarketsOrder) : [];
        let content = [];
        if (selectedMatchday && selectedMatchday.length) {
            marketsOrderConfig.forEach((market, index) => {
                content.push(this._generateMarketUI(ALL_MATCHDAY_MARKETS.find(mdMarket => mdMarket.name === market), selectedMatchday, index));
            });
            }

        let showTabs = [];

        let marketsUI = (<MultiTab tabs={showTabs} store={store} key={0} index={0} content={content}/>);
        let loadingOverlay;

        if (process.env.NODE_ENV !== 'development'
            ? this.state.selectedEventIndex !== 0
                ? this.state.matchdayUpdated === false
                : (selectedGame.controllerState !== undefined && selectedGame.controllerState[1] === PRE)
                    ? this.state.matchdayUpdated === false
                    : false
            : false) {
            loadingOverlay = (<div className={style.loadingOverlay}>
                <div className={style.loaderContainer}>
                    <div className={style.circleLoaderContainer}>
                        <div className={style.circleLoader}/>
                    </div>
                    {}
                </div>
            </div>)
            return (
                <div id={'matchday_card'} className={style.mainContainer}>
                    <div className={style.matchdayCard}>{loadingOverlay}{marketsUI}</div>
                </div>
            );
        }

        let noMoreBetsOverlay;
        let gameDisabledOverlay;
        let betSummaryOverlay;
        let eventBets;
        if (selectedMatchday) {
            eventBets = getAllWrappedMatchdayBets(this.state, selectedMatchday.channel).filter(
                (pBet) => selectedMatchday.some(selectedMatchdayEvent => pBet.Bets[0].EventId === selectedMatchdayEvent.eventId.toString()) && pBet.Bets[0].Channel === selectedMatchday[0].channel
            );
        }

        if (selectedMatchday && this.props.overlay === undefined) {
            for (let i = 0; i < this.state.noMoreBetsEventList.length; i++) {
                if (this.state.noMoreBetsEventList[i].eventId === selectedMatchday[0].eventId && this.state.noMoreBetsEventList[i].gameChannel === selectedGame.channel) {
                    let overlayText;
                    if (selectedGame.controllerState !== undefined && (selectedGame.controllerState[1] === PRE || selectedGame.controllerState[1] === NMB)) {
                        noMoreBetsOverlay = (
                            <div className={overlayStyle.overlay}>
                                <div className={overlayStyle.overlayText} id={'overlayText'}>
                                    {getText('NO_MORE_BETS', this.props.store)}
                                </div>
                            </div>
                        );
                    } else if (selectedGame.controllerState !== undefined && (selectedGame.controllerState[1] === VID || selectedGame.controllerState[1] === RES)) {
                        if (eventBets && eventBets.length > 0) {
                            eventBets.sort(function (a, b) {
                                if (a.Bets.length > b.Bets.length) return 1;
                                if (a.Bets.length < b.Bets.length) return -1;
                                if (a.Bets[0].LastUpdatedDate > b.Bets[0].LastUpdatedDate) return 1;
                                if (a.Bets[0].LastUpdatedDate < b.Bets[0].LastUpdatedDate) return -1;
                            });
                            betSummaryOverlay = (
                                <MatchdayActiveBetsSummary store={this.props.store} activeBets={eventBets}/>);
                        } else {
                            noMoreBetsOverlay = (
                                <div className={overlayStyle.overlay}>
                                    <div className={overlayStyle.overlayText} id={'overlayText'}>
                                        <Fragment>
                                            {getText('EVENT_LIVE_MSG_LINE_1', this.props.store)} <br/>
                                            {getText('EVENT_LIVE_MSG_LINE_2', this.props.store)} <br
                                            class={style.display}/>
                                            {getText('EVENT_LIVE_MSG_LINE_3', this.props.store)}
                                        </Fragment>
                                    </div>
                                </div>
                            );
                        }
                    }
                    break;
                }
            }
        }

        if (selectedMatchday && this.props.overlay === undefined) {
            if (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === HARD_SUSPENDED ||
                (storeData.vpp.games[storeData.vpp.selectedGameIndex].state.toString() === SOFT_SUSPENDED && betSummaryOverlay === undefined)) {
                gameDisabledOverlay = (
                    <div className={style.noMoreBetsOverlay}>
                        <div className={style.noMoreBetsText} id={'gameDisabled'}>
                            {getText('GAME_DISABLED', this.props.store)}
                        </div>
                    </div>
                );
            }
        }

        let overlay;
        if (this.props.overlay) {
            overlay = this.props.overlay;
        } else if (gameDisabledOverlay) {
            overlay = gameDisabledOverlay;
        } else if (betSummaryOverlay) {
            overlay = betSummaryOverlay;
            marketsUI = ''; // clear markets UI when bet summary is displayed
        } else {
            overlay = noMoreBetsOverlay;
        }

        return (
            <div id={'matchday_card'} className={style.mainContainer}>
                <div className={style.matchdayCard}>{overlay}{marketsUI}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MatchdayTextCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/containers/matchdayTextCard.js